import type { ReleaseThemeId } from 'fym-shared/src/music24/releaseThemes';
import type { FrameWordState } from './frameShapes';
/* eslint-disable css-modules/no-unused-class -- the theme and layout classes are picked by id at run time */
import styles from './AssetFrame.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** The class of each theme. The id of Noir is `dark`; its class is `noir` (design s). */
const THEME_CLASS: Readonly<Record<ReleaseThemeId, string | undefined>> = {
  clean: styles.clean,
  hype: styles.hype,
  dreamy: styles.dreamy,
  dark: styles.noir,
  warm: styles.warm,
  retro: styles.retro,
  neon: styles.neon,
  handmade: styles.handmade,
};

/** The class of the theme on a frame. */
export function frameThemeClass(themeId: ReleaseThemeId): string | undefined {
  return THEME_CLASS[themeId];
}

/** The texture of the theme (design s `texcls`): grain, paper, the glow of Dreamy, or none. */
export function frameTextureClass(themeId: ReleaseThemeId): string | undefined {
  switch (themeId) {
    case 'dark':
    case 'retro':
    case 'warm':
      return styles.grain;
    case 'handmade':
      return styles.paper;
    case 'dreamy':
      return styles.glow;
    case 'clean':
    case 'hype':
    case 'neon':
      return undefined;
  }
}

/** The class of a word of the sung line. */
export function frameWordClass(state: FrameWordState): string | undefined {
  switch (state) {
    case 'lit':
      return undefined;
    case 'now':
      return styles.now;
    case 'off':
      return styles.off;
  }
}
